import { Text, View } from 'components';
import Base, { Config } from 'components/scourge/Base';
import React from 'react';
import ClassItem from './components/classItem';
import cx from 'classnames'
import styles from './index.module.scss';
import { history } from 'modules/navigator';

interface State {
  lists: any[];
  page: number,
  tid?: number
  isEnd: boolean
  tags: any[]
  id?: any
  type?: any
}

let lock = false;

export default class ScoresRule extends Base<any> {
  public config: Config = {
    navigationBarTitleText: '维修课程'
  };

  public state: State = {
    lists: [],
    page: 1,
    isEnd: false,
    tags: []
  };
  
  public didMount() {

    this.setState({
      id: this.props.location.state? this.props.location.state.id : undefined,
      type: this.props.location.state? this.props.location.state.type : undefined
    })
    this.handleTab(this.props.location.state? this.props.location.state.id : undefined)
    this.getTags()
    
    let _this = this;
    window.addEventListener('scroll', (e) => {
        _this.handleScroll(e);
    });
  }

  private handleScroll = (e) => {
    // console.log(e)
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.body.scrollHeight-window.innerHeight
    // console.log(
    //   scrollTop,
    //   document.body.scrollHeight-window.innerHeight
    // )
    if(height < 0){return;}
    if(scrollTop > height-10 && !this.state.isEnd && !lock){
      lock = true;
      this.getLists()
    }
  }

 

  public render() {
    const { lists, tags, tid, type } = this.state;

    return (
      <View className={styles.container}>
        
        <View className={styles.page}>
          
          
          <View className={styles.body}>

              <div className={styles.tabsBox}>
                <View className={styles.tabs}>
                  <View className={cx(styles.tab, {
                    [styles.active]: tid == undefined
                  })} onClick={this.handleTab.bind(null,'')}
                  >
                    <Text className={styles.p}>全部分类</Text>
                  </View>
                  {tags.map(res => (
                    <View key={res.id} className={cx(styles.tab, {
                      [styles.active]: tid == res.id
                    })} onClick={this.handleTab.bind(null,res.id)}>
                      <Text className={styles.p}>{res.name}</Text>
                    </View>
                  ))}
                  
                </View>
              </div>

              <View className={styles.sec}>
                <View className={styles.list}>

                  {lists.map(it => (
                    <ClassItem key={it.id} data={it} type={type} />
                  ))}
                  
                </View>
              </View>
            
            
          </View>

        </View>

      </View>
    );
  }

  private getTags = async() => {
    const { status, body } = await this.apiClient.base.getCourseTag()
    if(status == 10000) {
      this.setState({
        tags: body
      })
    }
  }

  private handleTab = e => {
    this.setState({
      tid: e == ''? undefined : e,

      isEnd: false,
      page: 1,
      lists: []
    },() => {
      this.getLists()
    })
  }

  private getLists = async() => {
    const { lists, page, tid, isEnd, type } = this.state
    if(isEnd){return;}
    const params = type == 'mine'? {
      page
    }: {
      page,
      lid: null,  //讲师ID
      tid,        //专区ID
      keywords: ''
    }
    for (let propName in params) { 
      if (params[propName] === null || params[propName] === undefined || params[propName] === '') {
        delete params[propName];
      }
    }

    const { status, body } = type == 'mine'?
    await this.apiClient.base.mineCourse(params):
    await this.apiClient.base.getCourse(params)
    // console.log(body)
    if(status == 10000) {
      const newList = [...lists, ...body];
      this.setState({
        lists: newList,
        page: page+1,
        isEnd: body.length < 1
      })
    }else {

    }
    lock = false;
  }


}
